import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FilledUpAndDownIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FilledUpAndDown",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m9 21 6.86 6.86L22.71 21z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.86 29c-.3 0-.59-.12-.81-.33l-6.86-6.86c-.33-.33-.42-.82-.25-1.25.18-.43.59-.71 1.06-.71h13.71c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-6.86 6.86c-.21.21-.5.33-.81.33Zm-4.1-6.86 4.1 4.1 4.1-4.1zM9 11.86 15.86 5l6.85 6.86z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.71 13H9c-.46 0-.88-.28-1.06-.71s-.08-.92.25-1.25l6.86-6.86c.43-.43 1.19-.43 1.62 0l6.86 6.86c.33.33.42.82.25 1.25-.18.43-.59.71-1.06.71Zm-10.95-2.29h8.2l-4.1-4.1z"
    })]
  }));
};